import { Dispatch } from 'redux';

import { TagPayload } from '@/features/PCP/containers/FilterTagsContainer';
import { setPageNumber } from '@/store/redux/actions/pages/pcp';

import { IReduxActionProps } from './../../../../../Utils/index';

export const SET_FILTER_VEHICLE_TYPE = 'SET_FILTER_VEHICLE_TYPE';
export const DELETE_FILTER_VEHICLE_TYPE = 'DELETE_VEHICLE_TYPE';
export const RESET_FILTER_VEHICLE_TYPE = 'RESET_VEHICLE_TYPE';

export const setFilterVehicleType = (vehicleType: {
  vehicleType: string[];
  doors: string;
  minSeats: number;
  maxSeats: number;
}) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: SET_FILTER_VEHICLE_TYPE,
      payload: vehicleType,
    });
  };
};

export const deleteFilterVehicleType = (payload: TagPayload) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: DELETE_FILTER_VEHICLE_TYPE,
      payload,
    });
  };
};

export const resetVehicleTypeFilter = (): IReduxActionProps => {
  return {
    type: RESET_FILTER_VEHICLE_TYPE,
  };
};
